import PiStatistics from '../../../../../pages/vip/features/pi-statistics/pi-statistics';

export default PiStatistics;
